import React from 'react';
import ToggleSwitch from './ToggleSwitch';
import RefreshState from './RefreshState';

const ClusterModule = ({ showTooltip }) => {
    return (
        <div className="flex items-center justify-between px-4 py-2 gap-3 bg-white ml-2 rounded-lg shadow-sm">
            <div className='flex flex-col'>
                <span className='text-sm md:text-normal'>Service Hub</span>
            </div>
            <ToggleSwitch showTooltip={showTooltip} />
            <RefreshState />
        </div>
    );
};

export default ClusterModule;
